// @core/api/endpoints/workflow/register_node_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  NodeTypeResponse,
  RegisterNodeTypeRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Register node type
 * Registers a new node type in the workflow engine. Products can register custom node types that appear in the visual editor.
 */
export async function RegisterNodeType(
  data: RegisterNodeTypeRequest,
  options?: RequestOptions
): Promise<NodeTypeResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/node-types`;
  const requestOptions = options;
  return client.post<NodeTypeResponse>(requestPath, data, requestOptions);
}
